const { filterActive } = require('../utils');

const viewport = document.querySelector('map-viewport');
viewport.init('google', 'AIzaSyAbvtFai2_G3xh6p1NCFpOfxdqUstrXQzc');

const fromLatLon = ({ lat, lon }) => ({ lat, lng: lon });
const transformSeniors = (d) =>
  d.map(({ location, name, category, ...rest }) => ({
    ...fromLatLon(location),
    name: name.trim(),
    tags: [category],
    ...rest,
  }));

const toggleContent = (d) => (
  (document.querySelector('div.loading').style.display = 'none'),
  (document.querySelector('div.content').style.display = 'block') && d
);
const URL = process.env.API;
const getData = () =>
  fetch(`${URL}/cache/seniorscard`)
    .then((res) => res.json())
    .then(filterActive)
    .then((d) => viewport.load(transformSeniors(d)))
    .then(toggleContent);
viewport.init('google', 'AIzaSyAbvtFai2_G3xh6p1NCFpOfxdqUstrXQzc').then(getData);

let footerExpanded = false;
const footerButton = document.getElementById('FooterButton');
const list = document.querySelector('.map-list-container');
const footer = document.getElementById('FooterContainer');
const viewportContainer = document.querySelector('.map-viewport-container');
const recordCount = document.querySelector('.record-counts');

footerButton.addEventListener('click', () => {
  footerExpanded = !footerExpanded;
  footer.style.bottom = footerExpanded ? 0 : '';
  footer.style.overflow = footerExpanded ? 'scroll' : 'hidden';
});

list.addEventListener('click', () => {
  setTimeout(() => {
    const closeButton = document.querySelector('map-selection button[close-button="true"]');
    const mapSelection = document.querySelector('map-selection');
    list.classList.add('mobile-hidden-by-selection');
    recordCount.classList.add('mobile-hidden-by-selection');
    mapSelection.scrollTop = 0;

    closeButton.addEventListener('click', () => {
      list.classList.remove('mobile-hidden-by-selection');
      recordCount.classList.remove('mobile-hidden-by-selection');
    });
  });
});

const selection = document.querySelector('map-selection');

// Click phone number link
selection.addEventListener('click-phone', ({ detail }) =>
  window.open(`tel:${detail.phone}`, '_self')
);

// Click webiste link
selection.addEventListener('click-link', ({ detail }) => {
  window.open(detail.web, '_blank');
});

// Click get directions
selection.addEventListener('click-directions', ({ detail }) => {
  window.open(
    `https://www.google.com/maps/dir/?api=1&destination=${detail.address}&travelmode=driving`
  );
});

const reportBusinessUrl =
  'https://customervoice.microsoft.com/Pages/ResponsePage.aspx?id=aHr5Hqvo7UShbbV5_i182N5cdQRFA79Dr5WwJugBHeFUMTFCMUtVNlA2RFkwSDJCRktMVjJIMUg1NS4u';
const encode = (v) => encodeURIComponent(v);
const asQuery = (v) =>
  `&ctx={ bid: "${v.id}", bname: "${encode(v.name)}", baddress: "${encode(
    v.address
  )}", locale: "en", dataindex: "seniors"  }`;

// Report business button
selection.addEventListener('click-report-business', ({ detail }) => {
  window.open(`${reportBusinessUrl}${asQuery(detail)}`, '_blank');
});

const toggleButton = (btn) =>
  btn.style.display === 'flex' ? (btn.style.display = 'none') : (btn.style.display = 'flex');

// Share business button

// Add <a> tags href with links to social media
const shareBusiness = (url) => {
  document.querySelectorAll('.share-business-dropdown a').forEach((a, i) => {
    a.target = '_blank';
    switch (i) {
      case 0:
        a.href = `https://www.facebook.com/sharer.php?u=${url}`;
        break;
      case 1:
        a.href = `https://twitter.com/intent/tweet?text=${url}`;
        break;
      case 2:
        a.href = `https://www.linkedin.com/sharing/share-offsite/?mini=true&url=${url}`;
        break;
      case 3:
        a.href = `https://api.whatsapp.com/send/?text=${url}`;
        break;
      case 4:
        a.href = `mailto:?subject=Check out this business&body=${url}`;
        break;
      default:
        break;
    }
  });
};

selection.addEventListener('click-share-business', () => {
  const shareButton = document.querySelector('.share-business-dropdown');
  toggleButton(shareButton);
  shareBusiness(window.location.href);
});

const mapViewButton = document.getElementById('map-view-tab-button');
const listViewButton = document.getElementById('list-view-tab-button');
// Switch to map view
mapViewButton.addEventListener('click', () => {
  viewportContainer.classList.remove('mobile-hidden-by-view');
  list.classList.add('mobile-hidden-by-view');
  mapViewButton.style.borderBottom = '2px solid red';
  listViewButton.style.borderBottom = 'medium none';
});

// Switch to list view
listViewButton.addEventListener('click', () => {
  viewportContainer.classList.add('mobile-hidden-by-view');
  list.classList.remove('mobile-hidden-by-view');
  mapViewButton.style.borderBottom = 'medium none';
  listViewButton.style.borderBottom = '2px solid red';
});
